import { format, parseISO } from 'date-fns';

/** Shared bits between the referrals dashboard (`/admin/referrals`) and
 *  the per-code drill-in (`/admin/referrals/:code`). */

export const usd = (cents: number) => `$${(cents / 100).toFixed(0)}`;

export const fmtDate = (iso: string | null) =>
  iso ? format(parseISO(iso), 'MMM d, yyyy') : '—';

// Marketing site that hosts the landers + the ?promo= capture.
const SITE_URL = 'https://systemlabs.com';
export const referralLink = (code: string) => `${SITE_URL}/?promo=${code}`;

export function Stat({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2">
      <span className="text-11 uppercase tracking-wide text-ink-muted">
        {label}
      </span>
      <span className="type-label-md font-medium">{children}</span>
    </div>
  );
}

export function Th({
  children,
  align,
}: {
  children?: React.ReactNode;
  align?: 'right';
}) {
  return (
    <th
      className={`px-12 py-8 font-medium ${
        align === 'right' ? 'text-right' : ''
      }`}
    >
      {children}
    </th>
  );
}

export function Td({
  children,
  align,
}: {
  children: React.ReactNode;
  align?: 'right';
}) {
  return (
    <td className={`px-12 py-8 ${align === 'right' ? 'text-right' : ''}`}>
      {children}
    </td>
  );
}
